import * as THREE from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { TDSLoader } from 'three/examples/jsm/loaders/TDSLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { getCabinetStructure } from './lib/chromeExtensionsData';
import { ProxyManager } from './lib/ProxyManager';
import { Corps_cabinet } from './Corps_cabinet';
import { Renderer } from './lib/Renderer';
import { Model3d } from './lib/Model3d';
import { Camera } from './lib/Camera';
import { Scene } from './lib/Scene';
import { tween } from './lib/TWEEN';
import { Data } from './lib/Data';
import { Env } from './lib/Env';
import { JPG } from './lib/JPG';
import { ID } from './lib/ID';

const proxyManager = new ProxyManager();

function start(data) {
	const proxy = proxyManager.getProxy(data.canvasId);
	proxy.ownerDocument = proxy; // HACK!
	// self.document = {}; // HACK!
	self.dispatchEvent(new CustomEvent('init', {
		detail: {
			canvas: data.canvas,
			inputElement: proxy,
			data: data.data
		}
	}))
	// init({
	// 	canvas: data.canvas,
	// 	inputElement: proxy,
	// 	data: data.data,
	// });
}

function makeProxy(data) {
	proxyManager.makeProxy(data);
}

const handlers = {
	start,
	makeProxy,
	event: proxyManager.handleEvent,
};

self.onmessage = async function (e) {
	if (Renderer.animate) {
		Renderer.animate.setRendererFlag(120);
	}
	const fn = handlers[e.data.type];
	if (typeof fn !== 'function') {
		try {
			if (e.data.operations) {
				const object = Scene.scene.getObjectById(parseInt(e.data.operations.id));
				switch (e.data.operations.property) {
					case 'glftExport':
						if (e.data.operations.object_id) {
							Model3d.gltfExport(Scene.scene.getObjectById(parseInt(e.data.operations.object_id)));
						} else {
							Model3d.gltfExport();
						}
						break;
					case 'visible':
						object.visible = e.data.operations.value;
						break;
					case 'size':
						object.scale[e.data.operations.axis] = e.data.operations.value / e.data.operations.oryg;
						break;
					case 'rotation':
						object.rotation[e.data.operations.axis] = e.data.operations.value * (Math.PI / 180);
						break;
					case 'position':
						object.position[e.data.operations.axis] = e.data.operations.value * Env.size_units;
						break;
					case 'colorit':
						Scene.scene.traverse(node => {
							if (node.isMesh) {
								if (node.material.userData.color) {
									if (e.data.operations.value) {
										node.material.color.set(node.material.userData.color);
									} else {
										node.material.color.set(0xffffff);
									}
								}
							}
						});
						break;
					case 'axeshelper':
						if (object.userData.axesHelper) {
							object.remove(object.getObjectById(parseInt(object.userData.axesHelper)));
							delete object.userData.axesHelper;
							Scene.scene.remove(Scene.scene.getObjectById(parseInt(Scene.scene.userData.axesHelper)));
							delete Scene.scene.userData.axesHelper;
						} else {
							let axesHelper = new THREE.AxesHelper();
							object.add(axesHelper);
							object.userData.axesHelper = axesHelper.id;
							let axesHelperScene = new THREE.AxesHelper();
							Scene.scene.add(axesHelperScene);
							Scene.scene.userData.axesHelper = axesHelperScene.id;
						}
						break;
					case 'cameraDefault':
						const time = 1000;
						const json = Env.cameraDefault;
						tween(Camera.camera, 'fov', json.camera_fov, time, false, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.camera, 'near', json.camera_near, time, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.camera, 'far', json.camera_far, time, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.camera.position, 'x', json.camera_position_x, time, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.camera.position, 'y', json.camera_position_y, time, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.camera.position, 'z', json.camera_position_z, time, false, () => { Camera.camera.updateProjectionMatrix(); });
						tween(Camera.orbitControls.target, 'x', json.controls_target_x, time);
						tween(Camera.orbitControls.target, 'y', json.controls_target_y, time);
						tween(Camera.orbitControls.target, 'z', json.controls_target_z, time);
						break;
					case 'zoomin': {
						Camera.camera.fov -= 1;
						Camera.camera.updateProjectionMatrix();
					}
						break;
					case 'zoomout': {
						Camera.camera.fov += 1;
						Camera.camera.updateProjectionMatrix();
					}
						break;
					case 'top':
						Camera.orbitControls.target.y -= 1;
						break;
					case 'bottom':
						Camera.orbitControls.target.y += 1;
						break;
					case 'left':
						Camera.orbitControls.target.x += 1;
						break;
					case 'right':
						Camera.orbitControls.target.x -= 1;
						break;
					case 'reloadModel3D':
						Model3d.unload(Scene.scene, function () {
							ID.setDefault();
							Data.get(e.data.operations.data);
						});
						break;
					case 'cameraSettings':
						if (e.data.operations.json) {
							Camera.setCameraSettings(e.data.operations.json);
						} else {
							self.postMessage({ cameraSettings: Camera.getCameraSettings(), now: e.data.operations.now, action:e.data.operations.action });
						}
						break;
					case 'customIconSave':
						const response = await JPG.fetch(e.data.operations.url, e.data.operations.callback, e.data.operations.error);
						if (response.callback && response.success === 'ok') {
							self.postMessage({ callback: response.callback });
						} else if (response.callback) {
							self.postMessage({ callback: response.error });
						}
						break;
					case 'cabinetPositions':
						if (e.data.operations.json) {
							Corps_cabinet.cabinetPositions(e.data.operations.json);
						} else {
							self.postMessage({ cabinetPositions: Corps_cabinet.cabinetPositions(), now: e.data.operations.now });
						}
						break;
					case 'exportLayout': {
						const jpg = await JPG.export(e.data.operations.factor, null, null, true);
						self.postMessage({ jpgBlob: jpg });
						Model3d.gltfExport();
						self.postMessage({ exportLayout: Camera.getCameraSettings() });
					} break;
					case 'geteKorpusData':
						self.postMessage({ type: "FROM_PAGE", cabinets: JSON.parse(JSON.stringify(getCabinetStructure())) });
						break;
					case 'cabinet_add': {
						const index = e.data.operations.cabinet_index;
						if (Scene.scene.getObjectByName(`box${index}`)) {
							Scene.scene.getObjectByName(`box${index}`).visible = true;
							ID.cabinets.items.push( Scene.scene.getObjectByName(`box${index}`).id );
						} else {
							new Corps_cabinet(Env.cabinets_cart_data[index], `box${index}`, index);
						}
					} break;
					case 'cabinet_remove': {
						const index = e.data.operations.cabinet_index;
						Scene.scene.getObjectByName(`box${index}`).visible = false;
						const item = ID.cabinets.items.find(cabinet => Scene.scene.getObjectByName(`box${index}`).id === cabinet);
						const arrayIndex = ID.cabinets.items.indexOf(item);
						if (arrayIndex !== -1) {
							ID.cabinets.items.splice(arrayIndex, 1);
						}
					} break;
					case 'addModel': {
						try {
							const arrayBuffer = e.data.operations.arrayBuffer;
							let model, modelid;
							if(e.data.operations.extension === 'GLTF') {
								model = await new Promise( async function(resolve, reject){
									const loader = new GLTFLoader();
									const dracoLoader = new DRACOLoader();
									dracoLoader.setDecoderPath('draco/');
									loader.setDRACOLoader(dracoLoader);
									// loader.parse(arrayBuffer, '', function(model){
									// 	resolve(model.scene.children[0]);
									// })
									const blob = new Blob([arrayBuffer], {type: 'application/octet-stream'});
									const objectURL = URL.createObjectURL(blob);
									const model = await loader.loadAsync(objectURL);
									model.scale.set(Env.size_units, Env.size_units, Env.size_units);
									resolve(model.scene.children[0]);
								});
							} else if(e.data.operations.extension === 'OBJ') {
								model = await new Promise( async function(resolve, reject){
									const loader = new OBJLoader();
									const blob = new Blob([arrayBuffer], {type: 'application/octet-stream'});
									const objectURL = URL.createObjectURL(blob);
									const model = await loader.loadAsync(objectURL);
									model.scale.set(Env.size_units, Env.size_units, Env.size_units);
									resolve(model);
								});
							} else if(e.data.operations.extension === '3DS') {
								model = await new Promise( async function(resolve, reject){
									const loader = new TDSLoader();
									const blob = new Blob([arrayBuffer], {type: 'application/x-3ds'});
									const objectURL = URL.createObjectURL(blob);
									const model = await loader.loadAsync(objectURL);
									model.traverse(node=>{
										if(node.isMesh) {
											node.material = new THREE.MeshStandardMaterial({side: THREE.DoubleSide});
										}
									})
									model.scale.set(Env.size_units, Env.size_units, Env.size_units);
									resolve(model);
								});
							}					
							modelid = model.id;
							model.name = e.data.operations.filename;
							Scene.scene.add(model);
							self.postMessage( {addModel: { now: e.data.operations.now, modelid } } );
						} catch (e) { }
					} break;
					case 'removeModel': {
						const model = Scene.scene.getObjectById(e.data.operations.modelid);
						model.parent.remove(model);
						self.postMessage( {removeModel: { now: e.data.operations.now, modelid: e.data.operations.modelid } } );
					} break;
					case 'corp_width_description_update': {
						Scene.scene.getObjectById(ID.cabinets.items[0]).scale.x = e.data.operations.value / Corps_cabinet.width;
						Corps_cabinet.setWidthDescription(ID.cabinets.items[0], e.data.operations.description);
					} break;
					case 'corp_height_description_update': {
						Scene.scene.getObjectById(ID.cabinets.items[0]).scale.y = e.data.operations.value / Corps_cabinet.height;
						Corps_cabinet.setHeightDescription(ID.cabinets.items[0], e.data.operations.description);
					} break;
					case 'corp_depth_description_update': {
						Scene.scene.getObjectById(ID.cabinets.items[0]).scale.z = e.data.operations.value / Corps_cabinet.depth;
						Corps_cabinet.setDepthDescription(ID.cabinets.items[0], e.data.operations.description);
					} break;
					case 'updateCabinetDimensions': {
						Corps_cabinet.width = e.data.operations.width;
						Corps_cabinet.height = e.data.operations.height;
						Corps_cabinet.depth = e.data.operations.depth;
					} break;
					case 'setCabinetsCartData': {
						Env.data.data = e.data.operations.data;
						Env.setData();
						await JPG.setImageBitmaps();
            			await Model3d.setModels();
						Scene.removeCube();
						Env.draw.worldReady = true;
					} break;
				}
			} else {
				throw new Error({ message: 'no handler for type: ', data: e.data });
			}
		} catch (e) {
			console.debug(e);
		}
	} else {
		fn(e.data);
	}
}
